import React, { memo } from "react";
import { formats } from "investira.sdk";
import { Box } from "investira.react.components";

import { CardInfo } from "../../../components/molecules";

const AtivoHighlight = memo((props) => {
  const { ativo, cotacao } = props;

  let sxColumns =
    process.env.NODE_ENV !== "production"
      ? {
          xs: "repeat(2, 1fr)",
          sm: "repeat(3, 1fr)",
          md: "repeat(4, 1fr)",
          lg: "repeat(4, 1fr)",
          xl: "repeat(6, 1fr)",
        }
      : {
          xs: "repeat(2, 1fr)",
          sm: "repeat(3, 1fr)",
          md: "repeat(4, 1fr)",
          lg: "repeat(4, 1fr)",
          xl: "repeat(7, 1fr)",
        };

  if (!["ACN", "CTIM"].includes(ativo.ativo_tipo_id)) {
    sxColumns = {
      ...sxColumns,
      lg: "repeat(4, 1fr)",
      xl: "repeat(7, 1fr)",
    };
  }

  const xDataHmg = [
    {
      label: "Preço",
      value: cotacao?.hoje?.cotacao_ajustada,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      helpText: `Preço ajustado. Considera agrupamentos e desdobramentos. Atualizado em ${formats.formatDate(
        cotacao?.hoje
      )}.`,
      variant: "currency",
      copy: "muted",
      decimais: ativo.decimais,
    },
    {
      label: "Preço Min. 12 meses",
      value: cotacao.cotacao_min_12m,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      variant: "currency",
      decimais: ativo.decimais,
      helpText: `Preço ajustado. Considera agrupamentos e desdobramentos. Atualizado em ${formats.formatDate(
        cotacao?.hoje
      )}.`,
    },
    {
      label: "Preço Máx. 12 meses",
      value: cotacao.cotacao_max_12m,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      variant: "currency",

      decimais: ativo.decimais,
      helpText: `Preço ajustado. Considera agrupamentos e desdobramentos. Atualizado em ${formats.formatDate(
        cotacao?.hoje
      )}.`,
    },
    {
      label: "VaR",
      value: "12,53",
      subValue: true,
      valueProps: {
        variant: "h6",
      },
    },
    {
      label: "BVaR",
      value: "12,53",
      subValue: true,
      valueProps: {
        variant: "h6",
      },
    },
    {
      label: "Beta",
      value: "12,53",
      subValue: true,
      valueProps: {
        variant: "h6",
      },
    },
    {
      label: "Variação em 12 meses",
      value: cotacao.variacoes?.umAno,
      subValue: true,
      valueProps: {
        variant: "h6",
      },

      variant: "percentual",
      helpText: `Considera agrupamentos e desdobramentos`,
    },
    {
      label: "Variação do início",
      value: cotacao.variacoes?.inicio,
      subValue: true,
      valueProps: {
        variant: "h6",
      },

      variant: "percentual",
      helpText: `Considera agrupamentos e desdobramentos`,
    },
    {
      label: "Rentabilidade 12 meses",
      value: cotacao.rentabilidades?.umAno,
      subValue: true,
      valueProps: {
        variant: "h6",
      },

      variant: "percentual",
      helpText: `Considera agrupamentos, desdobramentos e proventos`,
    },
    {
      label: "Rentabilidade do início",
      value: cotacao.rentabilidades?.inicio,
      subValue: true,
      valueProps: {
        variant: "h6",
      },

      variant: "percentual",
      helpText: `Considera agrupamentos, desdobramentos e proventos`,
    },
    {
      label: "Índice de Sharpe 12 meses",
      value: "12,53",
      subValue: true,
      valueProps: {
        variant: "h6",
      },
    },
    {
      label: "Índice de Sharpe início",
      value: "12,53",
      subValue: true,
      valueProps: {
        variant: "h6",
      },
    },
  ];

  const xDataProd = [
    {
      label: "Cotação",
      value: cotacao?.hoje?.cotacao_ajustada,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      helpText: `Atualizado em ${formats.formatDate(cotacao?.hoje)}`,
      variant: "currency",
      copy: "muted",
      decimais: ativo.decimais,
    },
    {
      label: "Cotação Min. 12 meses",
      value: cotacao.cotacao_min_12m,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      variant: "currency",
      decimais: ativo.decimais,
    },
    {
      label: "Cotação Máx. 12 meses",
      value: cotacao.cotacao_max_12m,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      variant: "currency",
      decimais: ativo.decimais,
    },
    {
      label: "Variação em 12 meses",
      value: cotacao.variacoes?.umAno,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      variant: "percentual",
      helpText: `Considera agrupamentos e desdobramentos`,
    },
    {
      label: "Variação do início",
      value: cotacao.variacoes?.inicio,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      variant: "percentual",
      helpText: `Considera agrupamentos e desdobramentos`,
    },
    {
      label: "Rentabilidade 12 meses",
      value: cotacao.rentabilidades?.umAno,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      variant: "percentual",
      helpText: `Considera agrupamentos, desdobramentos e proventos`,
    },
    {
      label: "Rentabilidade do início",
      value: cotacao.rentabilidades?.inicio,
      subValue: true,
      valueProps: {
        variant: "h6",
      },
      variant: "percentual",
      helpText: `Considera agrupamentos, desdobramentos e proventos`,
    },
  ];

  const xData = process.env.NODE_ENV !== "production" ? xDataHmg : xDataProd;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: sxColumns,
        gap: 1.5,
      }}
    >
      {xData.map((xProps) => {
        return <CardInfo key={crypto.randomUUID()} {...xProps} />;
      })}
    </Box>
  );
});

export default AtivoHighlight;
